var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.meetingInstance.googleDocumentUrl)?_c('a',{attrs:{"href":_vm.meetingInstance.googleDocumentUrl,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n    Open document in Google\n  ")]):_c('i',[_vm._v("No document")])])
}
var staticRenderFns = []

export { render, staticRenderFns }